<template>
    <div class="wrapper">
      <input type="checkbox" :checked="value" @change="checkUncheck" />
      <span class="checkmark"/>
    </div>
</template>

<script>
 export default {
   props: {
     value: {
       type: Boolean,
       required: true
     }
   },
   methods: {
     checkUncheck(event) {
       this.$emit('input', event.target.checked);
     }
   }
 }
</script>



// WEBPACK FOOTER //
// src/components/Checkbox.vue